import { render, staticRenderFns } from "./Card.modal.vue?vue&type=template&id=25b67297"
import script from "./Card.modal.vue?vue&type=script&lang=js"
export * from "./Card.modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports